import { TAffiliateFirmListResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useAffiliateFirms() {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TAffiliateFirmListResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    'affiliate-firms/list',
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
